module.exports = __webpack_public_path__ + "img/usa-male.04896e51.png";